import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import React from "react";
import { useLanguage } from "../LanguageContext";
import { Helmet } from "react-helmet-async";

function ContactUs() {
  const API_URL = process.env.REACT_APP_API_URL;
  const IMG_BASE_URL = process.env.REACT_APP_API_BASE_URL_img;
  const { lang } = useLanguage();

  const [apiData, setApiData] = useState(null);
  const [PageData, setPageData] = useState(null);
  const { slug } = useParams();

  const getPage = async () => {
    if (!slug) return;

    try {
      const res = await axios.get(`${API_URL}/pages/get/slug/${slug}`, {
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
        },
      });

      setPageData(res.data?.data || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getData = async (apiName) => {
    try {
      const res = await axios.get(`${API_URL}/${apiName}`, {
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
        },
      });
      // setApiData(res.data?.data || []);
      setApiData(res.data?.data?.[0]);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getPage();
  }, [slug]);

  useEffect(() => {
    if (PageData?.apiName) {
      getData(PageData?.apiName);
    }
  }, [PageData?.apiName]);

  console.log("apiData", apiData);

  return (
    <div className="main-wrapper">
      {/* ================= SEO START ================= */}
      <Helmet>
        <title>{PageData?.pageTitle?.[lang] || "Technical Staff"}</title>

        <meta
          name="description"
          content={PageData?.metaDescription?.[lang] || ""}
        />

        <meta name="keywords" content={PageData?.keyWord?.[lang] || ""} />

        <meta property="og:title" content={PageData?.pageTitle?.[lang]} />
        <meta
          property="og:description"
          content={PageData?.metaDescription?.[lang]}
        />
        <meta
          property="og:image"
          content={`${IMG_BASE_URL}/${PageData?.photo}`}
        />
      </Helmet>
      {/* ================= SEO END ================= */}

      <section
        className="banner-section position-relative"
        style={{
          backgroundImage: `url(${IMG_BASE_URL}/${PageData?.photo})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="banner-title z_index1">
                <h1 className="banner-slider-title fw-500 text-white">
                  {PageData?.pageTitle?.[lang]}
                </h1>
                <ul className="breadcrumb-area m-0 p-0">
                  <li>
                    <Link to={"/"}>Home</Link>
                  </li>
                  <li>
                    <i className="fa-solid fa-angle-right"></i>
                  </li>
                  <li className="breadcrumb-title">
                    {PageData?.pageTitle?.[lang]}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="contact-page-section section-padding">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="section-heading">
                <h2 className="section-title fs-48 fw-600 mb-2">
                  {lang === "hi"
                    ? "संपर्क जानकारी"
                    : "Contact Information"}{" "}
                </h2>
                <p className="section-text fs-16 secondry-text m-0">
                  {lang === "hi"
                    ? "हमारे समर्पित अधिकारियों से संपर्क करें"
                    : "Get in touch with our dedicated officials"}{" "}
                </p>
              </div>
            </div>
          </div>
          <div className="row common-space">
            <div className="col-12">
              <div className="director-column">
                {/* <div className="director-card-header">
                  <div className="card-icon">
                    <i className="fa-solid fa-user"></i>
                  </div>
                  <div className="director-besic-info">
                    <div className="director-title fs-24 fw-600">
                      Dr. Ramcharan Bhattacharya
                    </div>
                    <p className="card-designation fs-18 fw-500 text-black mb-0">
                      Director
                    </p>
                  </div>
                </div> */}
                <div className="row director-detils-row row-gap">
                  <div className="col-md-6">
                    <div className="director-single-card">
                      <div className="inner-details conact-address-card position-relative z_index1">
                        <div className="director-contact-icon">
                          <i className="fa-solid fa-map-marker-alt"></i>
                        </div>
                        <div className="contact-details-info">
                          <div className="director-address">
                            <h4 className="addess-title fw-600 fs-24">
                              {lang === "hi" ? "पता" : "Address"}
                            </h4>
                            <p className="m-0 fs-18 text-black">
                              {apiData?.addressLine1?.[lang]} &{" "}
                              {apiData?.addressLine2?.[lang]}
                            </p>
                          </div>
                          <div className="director-address mt-3">
                            <h4 className="addess-title fw-600 fs-24">
                              {lang === "hi" ? "पिन कोड" : "Pin Code"}
                            </h4>
                            <p className="m-0 fs-18 text-black">
                              {apiData?.pinCode}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="director-single-card">
                      <div className="inner-details position-relative z_index1">
                        <div className="director-contact-icon d-none"></div>
                        <div className="director-contact">
                          <h4 className="addess-title fw-600 fs-24">
                            {lang === "hi"
                              ? "सामान्य पूछताछ"
                              : "General Enquiry"}
                          </h4>
                          <div className="single-contact">
                            <div className="contact-title me-2 fs-17 fw-500">
                              <i className="fas fa-envelope"></i>
                            </div>
                            <div className="contct-info">
                              <a
                                href={`mailto:${apiData?.email1}`}
                                className="fs-18"
                              >
                                {apiData?.email1}
                              </a>
                              <a
                                href={`mailto:${apiData?.email2}`}
                                className="fs-18"
                              >
                                {apiData?.email2}
                              </a>
                            </div>
                          </div>
                          <div className="single-contact">
                            <div className="contact-title me-2 fs-17 fw-500">
                              <i className="fas fa-phone"></i>
                            </div>
                            <div className="contct-info">
                              <span className="fs-18">
                                {apiData?.contactNumber}
                              </span>
                            </div>
                          </div>
                          <div className="single-contact">
                            <div className="contact-title me-2 fs-17 fw-500">
                              <i className="fas fa-clock"></i>
                            </div>
                            <div className="contct-info">
                              <span className="fs-18">
                                {apiData?.officeHours?.[lang]}
                              </span>
                            </div>
                          </div>

                          <div className="single-contact contact-social-media">
                            <a href={apiData?.instagramLink} target="_blank">
                              <div className="contact-title  fs-17 fw-500">
                                <i className="fab fa-instagram"></i>
                              </div>
                            </a>
                            <a href={apiData?.youtubeLink} target="_blank">
                              <div className="contact-title  fs-17 fw-500">
                                <i className="fab fa-youtube"></i>
                              </div>{" "}
                            </a>
                            <a href={apiData?.linkedinLink} target="_blank">
                              <div className="contact-title  fs-17 fw-500">
                                <i className="fab fa-linkedin"></i>
                              </div>
                            </a>
                            <a href={apiData?.twitterLink} target="_blank">
                              <div className="contact-title  fs-17 fw-500">
                                <i className="fab fa-twitter"></i>
                              </div>
                            </a>
                            <a href={apiData?.facebookLink} target="_blank">
                              <div className="contact-title  fs-17 fw-500">
                                <i className="fab fa-facebook"></i>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {apiData?.googleMapLink && (
                    <iframe
                      src={apiData.googleMapLink}
                      width="100%"
                      height="300"
                      style={{ border: 0 }}
                      allowFullScreen
                      loading="lazy"
                      title="Google Map"
                    ></iframe>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ContactUs;
